<template>
  <div class="form-detail">
    <p class="form-item">
      <span class="form-lt">企业全称</span>
      <span class="form-rt">{{orgdetail.name}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">统一社会信用代码</span>
      <span class="form-rt">{{orgdetail.code}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">营业执照</span>
      <span class="form-rt">
        <div style="overflow:hidden;border-radius:5px">
          <viewer :images="photo" class="seeBigImg">
            <img
              v-for="(src,index) in photo"
              :src="src"
              :key="index"
            >
          </viewer>
          <!-- <img v-for='img in imgList' style="width:100%;cursor:pointer" :key="img" alt="" @click="showBigImg(img)" :src='getImgUrl(img)'> -->
        </div>
        <!-- <el-dialog v-model="previewImg" size="tiny">
          <img width="100%" alt="" :src='imgName'>
        </el-dialog> -->
      </span>
    </p>
    <p class="form-item">
      <span class="form-lt">行业</span>
      <span class="form-rt">{{formatName}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">企业法人</span>
      <span class="form-rt">{{orgdetail.legalPerson}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">联系电话</span>
      <span class="form-rt">{{orgdetail.phone}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">注册地址</span>
      <span class="form-rt">
        <span class="form-registry">{{orgdetail.provinceName}}</span>
      <span class="form-registry">{{orgdetail.cityName}}</span>
      <span class="form-registry">{{orgdetail.countyName}}</span>
      <span class="form-registry">{{orgdetail.address}}</span>
      </span>
    </p>
    <p class="form-item">
      <span class="form-lt">中心坐标</span>
      <span class="form-rt">东经：{{orgdetail.longitude | formatDegree}}，北纬：{{orgdetail.latitude | formatDegree}}</span>
    </p>
    <p class="form-item" v-if="orgdetail.zone">
      <span class="form-lt">工业园区</span>
      <span class="form-rt">{{orgdetail.zone.name}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">规模</span>
      <span class="form-rt" v-if="orgdetail.regionType==1">单个区县</span>
      <span class="form-rt" v-if="orgdetail.regionType==2">跨区县</span>
      <span class="form-rt" v-if="orgdetail.regionType==3">跨市</span>
    </p>
    <p class="form-item">
      <span class="form-lt">所属区划</span>
      <span class="form-rt">
        <p v-for="m in orgdetail.regions" :key="m.id">
          <span class="form-registry">{{m.city.name}}</span>
      <span class="form-registry" v-for="n in m.county" :key="n.id">{{n.name}}</span>
    </p>
    </span>
    </p>
    <p class="form-item">
      <span class="form-lt">编制单位</span>
      <span class="form-rt">
        <p>
         <el-radio-group v-model="orgdetail.delegated" @change="changeradio">
            <el-radio :label="false">本单位</el-radio>
            <el-radio :label="true">编制单位</el-radio>
         </el-radio-group>
        </p>
    </span>
    </p>
    <div v-if="orgdetail.delegated == true">
      <p class="form-item">
        <span class="form-lt">编制单位名称</span>
        <span class="form-rt">
         <el-input size="small" placeholder="编制单位名称" v-model="orgdetail.delegateOrgName">
         </el-input>
       </span>
      </p>
      <p class="form-item">
        <span class="form-lt">编制单位地址</span>
        <span class="form-rt">
         <el-input size="small" placeholder="编制单位地址" v-model="orgdetail.delegateOrgAddr">
         </el-input>
        </span>
      </p>
      <p class="form-item">
        <span class="form-lt">编制单位联系人</span>
        <span class="form-rt">
         <el-input size="small" placeholder="编制单位联系人" v-model="orgdetail.delegateOrgLinkMan">
         </el-input>
         </span>
      </p>
      <p class="form-item">
        <span class="form-lt">编制单位联系电话</span>
        <span class="form-rt">
         <el-input size="small" placeholder="编制单位联系电话" v-model="orgdetail.delegateOrgPhone">
         </el-input>
        </span>
      </p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import weather from '../../data/emer/weather'
import company from '../../data/basic/plan/company.js'
export default {
  data() {
    return {
      input9: '',
      info_box: false,
      radio2: 1,
      imgList: [],
      photo:[],
      imgName: '',
      orgdetail: {
        // 地址
        address: '',
        // 营业执照编号
        code: '',
        // 营业执照图片文件名
        imgName: '',
        //  纬度
        latitude: '',
        // 经度
        longitude: '',
        // 机构名称
        name: '',
        // 电话
        phone: '',
        // 区划
        regions: [],
        // 子类型
        subType: '',
        // 机构类型
        type: '',
        // 三级联动
        RegionPartition: [],

        legalPerson: '',
        role: 1, // 我的角色,0=管理员，1=普通用户 ,
        zone: [],
        planId: '',
        delegateOrgAddr: '',
        delegateOrgLinkMan: '',
        delegateOrgName: '',
        delegateOrgPhone: '',
        delegated: false,
      },
      // 浏览大图
      previewImg: false,
      // 行业名称
      formatName: '',
      // 验证电话格式

    }
  },
  created() {
    this.orgdetail = JSON.parse(sessionStorage.datalistobj)
    let subjectId = this.orgdetail.id;
    let _this = this;
    this.sync_subject(subjectId).then(function (response) {
      _this.init();
    }).catch(function (error){
        _this.$message.error(error)
    });
  },
  methods: {
    ...mapMutations(['dataEntForm']),
    init(){
      this.orgdetail.delegated == null ? this.orgdetail.delegated = false : ''
      if (this.orgdetail.imgName && this.orgdetail.imgName.indexOf(';') !== -1) {
        this.imgList = this.orgdetail.imgName.split(';')
      } else {
        this.imgList.push(this.orgdetail.imgName)
      }
      this.dataEntForm(this.orgdetail)
      for(var i in this.imgList){
        let fullPath = this.getImgUrl(this.imgList[i])
        this.photo.push(fullPath)
      }
      this.imgName = this.getImgUrl(this.orgdetail.imgName);
      if (this.orgdetail.industry == null) {
        return
      } else {
        this.formatName = JSON.parse(JSON.stringify(this.orgdetail.industry)).name
      }
    },
    // 同步申报单位信息
    sync_subject(subjectId) {
      return new Promise((resolve, reject) => {
        (async() => {
          let result = await company.detail_entp({
            id: subjectId,
          })
          if (result.status) {
            Object.assign(this.orgdetail,result.data);
            sessionStorage.datalistobj = JSON.stringify(this.orgdetail);
            resolve(1);
          } else {
            reject('获取申报单位详情失败');
          }
        })()
      })
    },
    // 验证格式
    checkPhone(number) {
      let pattern=/(^[0-9]{3,4}\-[0-9]{3,8}$)|(^[0-9]{3,8}$)|(^\([0-9]{3,4}\)[0-9]{3,8}$)|(^0{0,1}13[0-9]{9}$)/;
      let phonePattern = /^1[3456789]\d{9}$/;
      return pattern.test(number) || phonePattern.test(number);
    },
    changeradio(val) {
      val == true ? this.info_box = true : this.info_box = false
    },
    pdfc() {
      this.$router.push('/pdf')
    },
    getImgUrl(name) {
      const TOKEN = sessionStorage.getItem('publicToken')
      if (!name) {
        return './../../../static/img/000.png'
      }
      if (name) {
        return `/api/basic/img/get?name=${name}&AccessToken=${TOKEN}`
      }
    },
    // showBigImg(file) {
    //   this.imgName = this.getImgUrl(file);
    //   this.previewImg = true;
    // },
    // 验证信息
    judge() {
      if (this.orgdetail.delegated == true) {
        if (this.orgdetail.delegateOrgName == null || this.orgdetail.delegateOrgAddr == null || this.orgdetail.delegateOrgLinkMan == null || this.orgdetail.delegateOrgPhone == null) {
          this.$message.error('编制单位信息不完善')
          return true
        } else {
          if (this.checkPhone(this.orgdetail.delegateOrgPhone) == false) {
            this.$message.error('编制单位联系电话有误')
            return true
          }
        }
      }
      //保存企业信息，方便同步信息
      this.saveEnt()
    },
    // 保存主体信息
    saveEnt() {
      (async() => {
        let save = await weather.save_subject(this.orgdetail)
        if (save.status) {
          return ''
        } else {
          this.$message.error(save.msg)
        }
      })()
    }
  }
}

</script>
<style lang="stylus" scoped>
.form-detail {
  width: 50%;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding-top: 20px;
  color: #48576a;
  font-size: 14px;
  .form-item {
    margin-bottom: 22px;
    min-height: 36px;
    line-height: 36px;
    display: flex;
    .form-lt {
      width: 130px;
      padding-right: 12px;
      margin-right: 60px;
      box-sizing: border-box;
      text-align: right;
    }
    .form-rt {
      flex: 1;
      .form-registry {
        margin-right: 30px;
      }
      .form-region {
        padding: 5px 30px;
        border: 1px solid #48576a;
        line-height: 30px
      }
    }
  }
}

.seeBigImg {
  img {
    display:inline-block;
    width:180px;
    margin-right:10px;
  }
}

</style>



// WEBPACK FOOTER //
// entDetail.vue?e2332108